module.exports = __webpack_public_path__ + "img/12_79.5e95027b.png";